module.exports = __webpack_public_path__ + "img/calculadora-credito.862a0edb.webp";